import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { z } from "zod";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  ADD_PROMO_CODE,
  GET_PROMO_CODE_BY_ID,
  PROMO_CODE_EDIT,
} from "../../../../services/ApiCalls";
import { toast } from "react-toastify";
import moment from "moment";

const validateDate = (data) => {
  if (!data) {
    return false;
  }
  if (new Date(data)?.getDate() === NaN) {
    return false;
  }
  return true;
};

const schema = z.object({
  promocode: z.string().min(1, { message: "Name is required" }),
  description: z.string().min(1, { message: "description is required" }),
  startDate: z
    .string()
    .refine(validateDate, { message: "start date is required" }),
  endDate: z.string().refine(validateDate, { message: "End date is required" }),
  amount: z
    .string()
    .min(1, { message: "amount is required" })
    .refine((data) => !isNaN(data), {
      message: "amount should be numeric",
    }),
  discount_type: z.nativeEnum(["flat", "percentage"], {
    errorMap: (issue, ctx) => {
      return { message: "Please select discount type" };
    },
  }),
});

const AddPromoCode = () => {
  const [activeInActive, setActiveInActive] = useState("");
  const navigate = useNavigate();

  const [promoCodesData, setPromoCodeData] = useState();
  const { id } = useParams();
  const statusRef = useRef();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(schema),
    defaultValues: {
      promocode: promoCodesData?.promocode || "",
      description: promoCodesData?.description || "",
      startDate: promoCodesData?.startDate
        ? moment(promoCodesData?.startDate).format("MM-DD-YYYY")
        : "",
      endDate: promoCodesData?.endDAte
        ? moment(promoCodesData?.endDAte).format("MM-DD-YYYY")
        : "",
      amount: promoCodesData?.amount.toString() || "",
      discount_type: promoCodesData?.discount_type || "",
    },
    values: {
      promocode: promoCodesData?.promocode || "",
      description: promoCodesData?.description || "",
      startDate: promoCodesData?.startDate
        ? moment(promoCodesData?.startDate).format("MM-DD-YYYY")
        : "",
      endDate: promoCodesData?.endDate
        ? moment(promoCodesData?.endDate).format("MM-DD-YYYY")
        : "",
      amount: promoCodesData?.amount.toString() || "",
      discount_type: promoCodesData?.discount_type || "",
    },
  });

  const getPromoCode = async (id) => {
    try {
      const res = await GET_PROMO_CODE_BY_ID(id);
      if (res?.data?.status === "success") {
        setPromoCodeData(res?.data?.data[0]);
        setActiveInActive(res?.data?.data[0]?.status);
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error("something went wrong");
    }
  };

  useEffect(() => {
    if (id) {
      getPromoCode(id);
    }
  }, [id]);

  const editHandler = async (id, data) => {
    try {
      const res = await PROMO_CODE_EDIT({
        ...data,
        promoId: id,
        status: statusRef?.current?.state?.checked ? "active" : "inactive",
      });

      if (res?.data?.status === "success") {
        toast.success(res?.data?.message);
        setPromoCodeData(res?.data?.data);
        setActiveInActive(res?.data?.data?.status);
        navigate("/promocodes");
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error("something went wrong");
    }
  };
  const onSubmit = async (data) => {
    if (id) {
   return    editHandler(id, data);
    }
    try {
      const res = await ADD_PROMO_CODE({
        ...data,
        status: statusRef?.current?.state?.checked ? "active" : "inactive",
      });

      if (res?.data?.status === "success") {
        toast.success(res?.data?.message);
        navigate("/promocodes");
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error("something went wrong");
    }
  };

  return (
    <>
      <section className="promocode py-3">
        <Container>
          <Row className="justify-content-center">
            <Col lg="12" className="my-2">
              <Link to="/promocodes" className="">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="41"
                  height="41"
                  viewBox="0 0 41 41"
                  fill="none"
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    width="40"
                    height="40"
                    rx="11.5"
                    fill="white"
                    stroke="#D9DADC"
                  />
                  <path
                    d="M23.1573 13.3669C23.0654 13.2747 22.9562 13.2016 22.836 13.1517C22.7157 13.1019 22.5869 13.0762 22.4567 13.0762C22.3265 13.0762 22.1976 13.1019 22.0774 13.1517C21.9572 13.2016 21.848 13.2747 21.7561 13.3669L15.1773 19.9456C15.1039 20.0189 15.0457 20.1059 15.006 20.2017C14.9662 20.2974 14.9458 20.4001 14.9458 20.5038C14.9458 20.6075 14.9662 20.7101 15.006 20.8059C15.0457 20.9017 15.1039 20.9887 15.1773 21.0619L21.7561 27.6406C22.144 28.0286 22.7694 28.0286 23.1573 27.6406C23.5452 27.2527 23.5452 26.6273 23.1573 26.2394L17.4257 20.4998L23.1652 14.7602C23.5452 14.3802 23.5452 13.7469 23.1573 13.3669Z"
                    fill="#1E232C"
                    stroke="#1E232C"
                    stroke-width="0.2"
                  />
                </svg>
              </Link>
            </Col>
            <Col lg="9" className="my-2">
              <Form onSubmit={handleSubmit(onSubmit)}>
                <div className="formWrpper px-sm-4 box p-3">
                  <Row>
                    <Col md="6" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label m-0 fw-sbold text-muted ps-2"
                      >
                        Name of Promo Code
                      </label>
                      <input
                        type="text"
                        className="form-control bg-white"
                        {...register("promocode")}
                      />
                      <p className="errorColor">
                        {errors?.promocode && errors.promocode.message}
                      </p>
                    </Col>
                    <Col md="6" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label m-0 fw-sbold text-muted ps-2"
                      >
                        Amount
                      </label>
                      <input
                        type="text"
                        className="form-control bg-white"
                        {...register("amount")}
                      />
                      <p className="errorColor">
                        {errors?.amount && errors.amount.message}
                      </p>
                    </Col>
                    {/* <Col md="6" className="my-2">
                      <label htmlFor="" className="form-label m-0 fw-sbold text-muted ps-2">
                        Restrict The Area
                      </label>
                      <input type="text" className="form-control bg-white" />
                    </Col> */}
                    <Col md="6" className="">
                      <Row>
                        <Col sm="6" className="my-2">
                          <label
                            htmlFor=""
                            className="form-label m-0 fw-sbold text-muted ps-2"
                          >
                            Start Date
                          </label>
                          <input
                            type="date"
                            className="form-control bg-white"
                            {...register("startDate")}
                          />
                          <p className="errorColor">
                            {errors?.startDate && errors.startDate.message}
                          </p>
                        </Col>
                        <Col sm="6" className="my-2">
                          <label
                            htmlFor=""
                            className="form-label m-0 fw-sbold text-muted ps-2"
                          >
                            Expiry Date
                          </label>
                          <input
                            type="date"
                            className="form-control bg-white"
                            {...register("endDate")}
                          />
                          <p className="errorColor">
                            {errors?.endDate && errors.endDate.message}
                          </p>
                        </Col>
                      </Row>
                    </Col>
                    <Col md="6" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label m-0 fw-sbold text-muted ps-2"
                      >
                        Discount Type
                      </label>

                      <select
                        className="form-control bg-white"
                        {...register("discount_type")}
                        defaultValue={"flat"}
                      >
                        <option value="flat">flat</option>
                        <option value="percentage">percentage</option>
                      </select>
                      <p className="errorColor">
                        {errors?.discount_type && errors.discount_type.message}
                      </p>
                    </Col>
                    <Col md="6" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label m-0 fw-sbold text-muted ps-2"
                      >
                        Description
                      </label>
                      <textarea
                        name=""
                        id=""
                        rows="3"
                        className="form-control bg-white"
                        {...register("description")}
                      ></textarea>
                      <p className="errorColor">
                        {errors?.description && errors.description.message}
                      </p>
                    </Col>
                    <Col md="4" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label m-0 fw-sbold text-muted ps-2"
                      >
                        Set Status of Promotion
                      </label>
                      <BootstrapSwitchButton
                        onlabel="Active"
                        onstyle="danger"
                        offlabel="Unactive"
                        offstyle="success"
                        width={147}
                        ref={statusRef}
                        checked={activeInActive === "active" ? true : false}
                        onChange={(e) => {
                          setActiveInActive(e ? "active" : "inactive");
                        }}
                      />
                      <p className="errorColor">
                        {errors?.status && errors.status.message}
                      </p>
                    </Col>
                    <Col lg="12" className="my-2">
                      <div className="btnWrpper mt-4 text-center">
                        <Button
                          className="d-inline-flex h-auto align-items-center justify-content-center commonBtn px-5"
                          // type="submit"
                          onClick={handleSubmit(onSubmit)}
                        >
                          Save
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Form>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AddPromoCode;
